import React, {forwardRef, memo, ReactNode} from 'react';
import {RouteName} from '@/app/constants/routing';
import {hasWeatherForLocationTypes, LocationType} from '@/common/constants/locationType';
import {useUrlBuilder} from '@/app/routing/useUrlBuilder';
import {RouterLink, RouterLinkProps} from '@/common/components/RouterLink';

interface LocationLinkProps extends Omit<RouterLinkProps, 'url' | 'ref'> {
	location: {
		id: string;
		type?: LocationType;
		title: string;
	};
	children?: ReactNode;
}

export const LocationLink = memo(
	forwardRef<HTMLElement, LocationLinkProps>((props, ref) => {
		const {location, children, ...nativeProps} = props;

		const urlBuilder = useUrlBuilder();

		const hasWeather = !location.type || hasWeatherForLocationTypes.includes(location.type);
		const url = hasWeather
			? urlBuilder(RouteName.weather, {location})
			: urlBuilder(RouteName.map, {location: location.id});

		return (
			<RouterLink ref={ref} url={url} {...nativeProps}>
				{children || location.title}
			</RouterLink>
		);
	}),
);

LocationLink.displayName = 'LocationLink';
